// extracted by css-extract-rspack-plugin
export default {"columns":"Block-module__columns___GOm87","column":"Block-module__column___sJBlt","title":"Block-module__title___xhwfP"};